
import { Component, Inject, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { GroupUserExternal } from '../../../backend/backendapi';

export type ExternalUserSelectModalTabFunctions = {
  clear?(): void;
  get selectedUsers(): GroupUserExternal[] | undefined,
};

@Component
export default class ExternalUserSelectModalTab extends Vue implements ExternalUserSelectModalTabFunctions {
  @Prop({ required: true })
  id!: string;
  @Prop({ required: true })
  title!: string;
  @Inject()
  addTab!: (tab: ExternalUserSelectModalTab) => void;
  @Inject()
  removeTab!: (tab: ExternalUserSelectModalTab) => void;

  visible = true;

  mounted() {
    this.addTab(this);
  }

  beforeDestroy() {
    this.removeTab(this);
  }

  //passthroughs
  clear(): void {
    for (let child of this.$children) {
      const clear = (child as unknown as ExternalUserSelectModalTabFunctions).clear;
      if (clear) {
        clear();
      }
    }
  }

  get selectedUsers(): GroupUserExternal[] {
    for (let child of this.$children) {
      const selectedUsers = (child as unknown as ExternalUserSelectModalTabFunctions).selectedUsers;
      if (selectedUsers) {
        return selectedUsers;
      }
    }
    return [];
  }
}
